const slugify = (value) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const mapWithSlug = (property) => ({
  ...property,
  slug: property.slug || slugify(property.name),
});

const getMapQuery = (property) => {
  const areaCode = String(property?.areaCode || '').trim();
  const address = String(property?.address || '').trim();
  const addressPart = areaCode && address ? `${areaCode} ${address}` : address || property.address;
  return `${property.name}, ${addressPart}, Norway`;
};

const getGoogleMapsQuery = (property) => {
  const areaCode = String(property?.areaCode || '').trim();
  const address = String(property?.address || '').trim();

  if (address && areaCode) {
    return `${areaCode} ${address}, Norway`;
  }

  if (address) {
    return `${address}, Norway`;
  }

  return getMapQuery(property);
};

const createGoogleMapsEmbedUrl = (property) => {
  const query = encodeURIComponent(getGoogleMapsQuery(property));
  return `https://www.google.com/maps?q=${query}&output=embed`;
};

const createGoogleMapsLink = (property) => {
  const query = encodeURIComponent(getGoogleMapsQuery(property));
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
};

export const propertyModel = {
  slugify,
  mapWithSlug,
  getMapQuery,
  createGoogleMapsEmbedUrl,
  createGoogleMapsLink,
};